import { env } from "@/env";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./en";
i18n.use(initReactI18next).init({
  resources: { en },
  lng: "en",
  debug: env.mode !== "production",
  interpolation: {
    escapeValue: false,
  },
});

export * from "./components";
export default i18n;
